/** Redux Toolkit slice names, for consistent reuse */
export enum SliceNames {
  USER = 'user',
  STORAGE = 'storage flow',
  RETURN = 'return flow',
  EDIT_STORAGE = 'edit storage',
  UI = 'ui',
  PACKAGING = 'packaging flow',
  M2_PPA = 'square meter/pay per area',
  STORAGE_UNIT = 'storage unit flow',
}

/**
 * Mapping of slice names and their respective state keys,
 * to assure code consistency and DRYness.
 */
export const stateKeyMappings: Record<SliceNames, string> = {
  [SliceNames.USER]: 'user',
  [SliceNames.STORAGE]: 'storageFlow',
  [SliceNames.RETURN]: 'returnFlow',
  [SliceNames.EDIT_STORAGE]: 'editStorageFlow',
  [SliceNames.UI]: 'ui',
  [SliceNames.PACKAGING]: 'packagingFlow',
  [SliceNames.M2_PPA]: 'squareMeterFlow',
  [SliceNames.STORAGE_UNIT]: 'storageUnitFlow',
} as const

/**
 * Redux Toolkit slice keys, as used in store
 */
export type reduxSliceKeys = keyof typeof stateKeyMappings

/**
 * Mapping of slice names and their respective reducer function names,
 * to assure code consistency and DRYness.
 *
 * Naming convention: Be consistent with naming of reducer functions...
 * - ...by form of action (add, remove, update etc.)
 * - ...by type of data they handle as payload (Orderline, ProductCategory etc.)
 */
export const reducerFunctionNames: {
  [K in keyof typeof SliceNames as SliceNames]: Record<string, string>
} = {
  [SliceNames.STORAGE]: {
    setOrderSuccessPayload: 'setOrderSuccessPayload',
    selectDateAndTime: 'selectDateAndTime',
  },
  [SliceNames.RETURN]: {
    setOrderSuccessPayload: 'setOrderSuccessPayload',
  },
  [SliceNames.EDIT_STORAGE]: {},
  [SliceNames.UI]: {
    setCity: 'setCity',
    setCountry: 'setCountry',
    setEstimatedTimeslotCost: 'setEstimatedTimeslotCost',
    setLanguage: 'setLanguage',
    setMainNavFixed: 'setMainNavFixed',
  },
  [SliceNames.PACKAGING]: {
    setOrderSuccessPayload: 'setOrderSuccessPayload',
  },
  [SliceNames.M2_PPA]: {
    setOrderSuccessPayload: 'setOrderSuccessPayload',
  },
  [SliceNames.USER]: {
    fetchUser: 'fetchUser',
  },
  [SliceNames.STORAGE_UNIT]: {},
}
